<template>
  <SideBar title="Inicio">
    <div class="max-w-xl mx-auto bg-white overflow-hidden shadow rounded-lg">
      <div class="px-4 py-5 sm:p-6 sm:flex">
        <div class="sm:w-1/2 text-center">
          <img
            class="inline-block h-20 w-20 sm:h-32 sm:w-32 rounded-full"
            src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
            alt=""
          />
        </div>
        <div class="sm:w-1/2 mt-2 sm:mt-0">
          <p class="text-lg font-semibold text-center">
            {{name}}
          </p>
          <p class="font-semibold mt-2">DNI:</p>
          <p>{{dni}}</p>
          <p class="font-semibold mt-2">Domicilio</p>
          <p>{{address}}</p>
        </div>
      </div>
    </div>
    <h2 class="text-xl font-semibold text-gray-900 mt-4">
      RESUMEN ESTADÍSTICO
    </h2>
    <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <div class="flex items-center">
            <div class="flex-shrink-0 bg-primary-500 rounded-md p-3">
              <IconSvg :solid="false" icon="users" class="h-6 w-6 text-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate"
                >
                  Clientes
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl leading-8 font-semibold text-gray-900">
                    16
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <div class="flex items-center">
            <div class="flex-shrink-0 bg-primary-500 rounded-md p-3">
              <IconSvg :solid="false" icon="briefcase" class="h-6 w-6 text-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate"
                >
                  Servicios
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl leading-8 font-semibold text-gray-900">
                    32
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <div class="flex items-center">
            <div class="flex-shrink-0 bg-primary-500 rounded-md p-3">
              <IconSvg :solid="false" icon="clipboard-check" class="h-6 w-6 text-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate"
                >
                  Evaluaciones
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl leading-8 font-semibold text-gray-900">
                    5
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white overflow-hidden shadow rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <div class="flex items-center">
            <div class="flex-shrink-0 bg-primary-500 rounded-md p-3">
              <IconSvg :solid="false" icon="cash" class="h-6 w-6 text-white" />
            </div>
            <div class="ml-5 w-0 flex-1">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate"
                >
                  Ganancias
                </dt>
                <dd class="flex items-baseline">
                  <div class="text-2xl leading-8 font-semibold text-gray-900">
                    S/ 543.60
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SideBar>
</template>

<script>
import api from "../../api";

import SideBar from "../../components/SideBar";
import IconSvg from "../../components/IconSvg";

export default {
  name: "WorkerHome",
  components: {
    SideBar,
    IconSvg
  },
  data() {
    return {
      name: '',
      dni: '',
      address: '',
    }
  },
  async mounted() {
    let response = await api.get(`/profile`)
    if (!response.ok) {
      return this.$toast.open({
        message: response.error || 'Ocurrió un error, vuelva a intentarlo',
        type: "error",
        duration: 8000,
        dismissible: true
      });
    }
    this.name = `${response.data.first_name} ${response.data.last_name_p} ${response.data.last_name_m}`
    this.dni = response.data.dni
    this.address = response.data.address
  },
};
</script>